import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { createWisoIntegration } from "../../../services/customer-services/customerIntegrationService";
import Toast from "../../../component/toastify/Index";

const WisoCallback = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const ownershipId = searchParams.get("iid");

    if (!ownershipId) {
      // no iid = invalid callback
      Toast("Missing ownershipId in callback from WISO", "error");
      navigate("/settings/integrations", { replace: true });
      return;
    }

    const saveIntegration = async () => {
      await createWisoIntegration(ownershipId);
      navigate("/settings/integrations", { replace: true });
    };

    saveIntegration();
  }, [navigate, searchParams]);

  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <h2>Connecting WISO MeinBüro…</h2>
      <p>Please wait while we finish the setup.</p>
      {/* replace with your spinner component */}
      <div className="spinner" />
    </div>
  );
};

export default WisoCallback;
